/**
 * The shell's fixed facts, from `proto/cider-shell.js` and `program/Nav.dc.html`.
 * The view *items* are not here: they come from the capability registry in
 * `@cider/domain/access` (Part 2), so the nav can never disagree with the policy.
 */

/** Rule 4 on the Nav page: phase changes a view's home, badges and countdown — never its items. */
export const PHASES = [
  ['onboarding', 'ONBOARDING'],
  ['planning', 'PLANNING'],
  ['setup', 'SETUP WEEK'],
  ['day', 'FESTIVAL DAY'],
  ['closeout', 'CLOSEOUT'],
] as const;

export type PhaseId = (typeof PHASES)[number][0];

/** Rule 1: one app, six views, each with a color tag — the token in tokens.css, never a hex here. */
export const VIEW_TAGS = {
  volunteers: 'var(--view-volunteers)',
  money: 'var(--view-money)',
  marketing: 'var(--view-marketing)',
  ops: 'var(--view-ops)',
  chairs: 'var(--view-chairs)',
  admin: 'var(--view-admin)',
} as const;

export type ViewId = keyof typeof VIEW_TAGS;
